import styled from 'styled-components';
import * as Common from '../../../../Styles';

const Theme = Common.Theme;

export const ItemDetails = styled(Common.FlexColumn)`
  gap: 0.25rem;
`;

export const Mappings = styled(Common.FlexColumn)`
	gap: 1rem;
  margin-top: 0.5rem;
`;

export const Mapping = styled(Common.FlexColumn)`
	gap: 0.5rem;
	padding: 0.5rem;
	border: 1px solid ${Theme.lightGrey};
	border-radius: 4px;
`;

export const MappingTitle = styled(Common.FlexRow)`
	color: ${Theme.darkGrey};
	font-size: 14px;
	font-weight: 600;
	text-transform: uppercase;
	align-items: center;
  padding-bottom: 0.5rem;
	border: 0px solid ${Theme.lightGrey};
  border-bottom-width: 1px;
`;

export const MappingDetails = styled(Common.FlexRow)`
	gap: 0.5rem;
	align-items: center;
`;

export const MappingDetailsColumn = styled(Common.FlexColumn)`
  gap: 0.5rem;
`;

export const ItemID = styled(Common.FlexRow)`
	font-size: 14px;
	font-weight: 600;
`;

export const Name = styled(Common.FlexRow)`
	font-size: 14px;
	font-weight: 600;
  text-overflow: ellipsis;
  color: ${Theme.darkGrey};
`;

export const Product = styled(Common.FlexColumn)`
  width: 12rem;
  gap: 0.25rem;
  padding: 0.5rem;
	border: 1px solid ${Theme.lightGrey};
	border-radius: 4px;
`;
